module.exports={
  message: {
    "Online Magazine": 'Magazine',
    "Browse Occupations":'Careers',
    "Find An Opportunity":"Find An Opportunity",
    "Qualifications":"Qualifications",
    "Self Assessment":"Self Assessment",
    "Home":"Home",
    "Job detail":"Job detail",
    "Browse Courses":"Courses",
    "Year":"Year",
    "Month":"Month",
    "Day":"Day",
    "monthsAgo":" Months ago",
    "weeksAgo":" Weeks ago",
    "daysAgo":" Days ago",
    "dayAgo":" Day ago",
    "today":" Today",
    "OccupationTitleSkillOrIndustry":"Occupation title, skill or industry",
    "All Education Level":"All Education Level",

    "Requirement":"Requirement",
    "Experience":"Experience",
    "EducationLevel":"Education Level",
    "Skills":"Skills",
    "outLook":"Outlook",
    "CareerPath":"Career Path",
    "Common Skills":"Common Skills",
    "Growing Skills":"Growing Skills",
    "Manpoweroutlook":"Projected demand",
    "Automationpotential":"Automation potential",
    "Private Sector":"Private Sector",
    "Government Sector":"Government Sector",
    "To know more":"To know more",
    "Share with":"Share with",
    "RelatedJobOpportunities":"Related Vacancies",
    "Opportunities":"Opportunities",
    "RelatedCourses":"Related Courses",
    "QR Courses":"QR Courses",
    "MOOC Courses":"MOOC Courses",
    "View all opportunities":"View all",
    "View all qualifications":"View all",
    "Related Job functions":"Related Job Functions:",
    "Discover career resources for educators and employers":"Explore training resources and learn more about career development",
    "link":"[link]",
    "forStart":'"',
    "for":'for ',
    "forEnd":'"',
    "Low":"Low",
    "High":"High",
    "Show more":"Show more",
    "Show less":"Show less",
    "Monthly salary":"Monthly salary",
    "All Job Functions":"All Job Functions",
    "Find a Job Opportunity":"Vacancies",
    "Career quizzes":"Career quizzes",
    "Hot Picks":"Hot Picks",
    "hotPicks":"Hot Picks",
    "Top 5 searches":"Top searches",
    "View all":"View all",
    "FInd out more":"Discover",
    "Stay":"Stay ahead of your career. Find your next job here.",
    "Job title, company name or skill, etc":"Job title, company name or skill, etc",
    "Job Functions":"Job Functions",
    "Search":"Search",
    "Learning and Upskilling":"Learning and Upskilling",
    "Learn from":"Learn from the best. Discover thousands of full time, part time and online courses.",

    "What careers would suit you?":"What careers would suit you?",
    "Various career":"Various career quizzes here can help you explore career pathways and develop insights into career decision-making based on your interests and talents",
    "Take a quiz":"Take a quiz",
    "Resources":"Resources",
    "Feedback":"Feedback",
    "About Human":"About Human Resources Planning Commission",
    "About Us":"About Us",
    "Privacy Policy":"Privacy Policy",
    "Disclaimer":"Disclaimer",
    "© 2019":" talent.gov.hk. All rights reserved.",
    "Self-Assessment":"Quizzes",
    "developmentTip":"This section is under development. Please ignore. ",
    "FT":"Full time",
    "PT":"Part time",
    "DL":"Distance learning",
    "EL":"Online/Mobile",
    "Not Applicable":"Not Applicable",
    "siteMap":"Site Map",
    "CourseInputTip":"Course title, Institution or skill, etc",
    "All Areas of Study":"All Areas of Study",
    "CEF":"CEF reimbursable courses",
    "All Learning Modes":"All Learning Modes",
    "All Course Providers":"All Course Providers",
    "Fewer Options":"Fewer Options",
    "More Options":"More Options",
    "results":" results",
    "item":"item",
    "QR number:":"QR number:",
    "Course Provider":"Course Provider",
    "Area of Study":"Area of Study",
    "Learning mode":"Learning Mode",
    "Level":"Level",
    "Pace of learning":"Pace of learning",
    "Effort":"Effort",
    "Length":"Length",
    "What youll learn":"What you'll learn",
    "Requirements":"Job requirements",
    "Prerequisites":"Prerequisites",
    "Go to course page":"Go to course page",
    "QR level 1-3":"Foundation certificate / diploma",
    "QR level 4":"Higher certificate / Higher Diploma / Associate Degree",
    "QR level 5":"Bachelor degree or equivalent",
    "QR level 6":"Postgraduate Certificate / Postgraduate Diploma / Master degree",
    "QR level 7":"Doctorate",
    "All Level of Positions":"All Level of Positions",
    "All Job Types":"All Job Types",
    "Organization":"Organization",
    "Job function(s)":"Job function(s)",
    "Department":"Department",
    "Level of position":"Level of position",
    "Salary":"Salary",
    "Job descriptions":"Job descriptions",
    "Job duties":"Job duties",
    "Advertising date":"Advertising date",
    "All Level":"All Course Levels",
    "Apply on":"Apply on",
    "Apply on2":"",
    "Apply":"Apply",
    "Other Job Opportunities":"Other Job Opportunities",
    "ViewAll":"View all",
    "jobTAndC":"talent.gov.hk contains job vacancies information from external sources and relevant links as a convenience to our users, and is not responsible for the content of these sites.",
    "EffortTip1":"",
    "EffortTip2":" hours/week",
    "week(s)":"week(s)",
    "noSearchResult":"There are no relevant results.",
    "Category":"Category",
    "Feature story":"Feature story",
    "Side story":"Side story ",
    "Column":"Column",
    "All":"All",
    "Careers Exploration":"Careers Exploration",
    "Vacancies Search":"Vacancies Search",
    "All articles":"All articles",
    "on this page":"What's on this page",
    "skillTips":"TIPS: Click on the skills to search for relevant courses.",
    "Relevant links":"Relevant Links",
    "assessmentDesc":"Various career quizzes here can help you explore career pathways and develop insights into career decision-making based on your interests and talents.",
    "Skill-Career Quiz":"Skill-Career Quiz",
    "Interest-Career Quiz":"Interest-Career Quiz",
    "Background-Career Quiz":"Background-Career Quiz",
    "getStarted":"Let's get started",
    "skillDesc":"Leverage your talents. This career quiz helps you quickly identify careers that are related to your strengths.",
    "skillContent1":"Tell us the skills and knowledge that you possess or are interested to acquire by answering simple questions.",
    "skillContent2":"We then identify careers in the database that match closest to your skill profile.  After the first six questions, the quiz will start returning a list of potential careers.  ",
    "skillContent3":"You may further explore the details by clicking into each suggested career.",
    "Start":"Start",
    "interestDesc1":"Learning about your interests, this career quiz can assist you to explore work you might like and find rewarding.",
    "interestDesc2":"This quiz adopts the ",
    "interestDesc3":"<a target='_blank' href='https://www.onetcenter.org/tools.html'>O*NET Mini Interest Profiler</a> ",
    "interestDesc4":".  It has 30 questions about your interests in work activities and identifies careers that match closest to your interests.",
    "interestDesc5":"After the first six questions, the quiz will start returning a list of potential careers that match your interests.  You may further explore the details by clicking into each suggested career anytime.",
    "interestDesc6":"Read each question carefully and decide how you would feel about doing each activity:",
    "Strongly Dislike":"Strongly Dislike",
    "Dislike":"Dislike",
    "Unsure":"Unsure",
    "Like":"Like",
    "Strongly Like":"Strongly Like",
    "interestDesc7":"Just think about if you would like or dislike doing the work.  Try NOT to think about whether you have enough education or training to do the work, or how much money you would make doing the work, etc.",
    "interestDesc8":"There are no right or wrong answers.Please take your time answering the questions. There is no need to rush!",
    "backgroundDesc":"Try this career quiz and get insights on careers that match your education and experience! ",
    "Q":"Q",
    "Your Career Matches":"Your Career Matches",
    "resultTip":"Results will be shown after answering 6 questions.",
    "Show result":"Show Results",
    "Your highest education attained:":"Your highest education attained: ",
    "Years of working experience:":"Your years of working experience:",
    "Your field of study:":"Your field of study:",
    "studyNote":"(Note: The field of study mostly refers to subject in your post-secondary education.  If you did not engage in any post-secondary education, you may choose one that you wish to study in the future.)",
    "Your current occupation:":"Your current occupation:",
    "NoMatchingResults":"No matching results.",
    "Issue":"Issue",
    "Number":"Number",
    "Years":"Years",
    "Field of study":"Field of study",
    "Job title":"Job title",
    "Try another quiz":"Try another quiz",
    "Log in Facebook to view comments":"Log in Facebook to view comments",
    "Feature Articles":"Feature Articles",
    "Columns":"Columns",
    "The Headline":"The Headline",
    "View Comments":"View Comments",
    "Read more:":"Read more:",
    "Recommended articles":"Recommended Articles",
    "Related Occupations":"Related Careers",
    "Published:":"Published:",
    "Select Issue":"Select Issue",
    "Feature articles":"Feature articles ",
    "feedbackDesc":"Thank you for visiting talent.gov.hk! We welcome your feedback. If you have any comments on the content of this website, please feel free to email us at feedback@talent.gov.hk.",
    "sendSuccess":"Your message was sent successfully. Thank you!",
    "Email":"Email",
    "Types of user":"Type of user",
    "Student":"Student",
    "Job seeker":"Job seeker",
    "Employee":"Employee",
    "Employer":"Employer",
    "CareerEducationCounsellor":"Career / education counsellor",
    "Others":"Others",
    "Age group":"Age group",
    "Below 18":"Below 18",
    "60 or above":"60 or above",
    "Type of feedback":"Type of feedback",
    "Enquiries":"Enquiries",
    "Outdated inaccurate information":"Outdated / inaccurate information",
    "Suggestions and recommendations":"Suggestions and recommendations",
    "Collaboration opportunities":"Collaboration opportunities",
    "Related Page":"Related page(s)",
    "Contact information":"Contact information",
    "Feedback form":"Feedback form",
    "Message":"Message",
    "Please enter message":"Please enter message",
    "Submit":"Submit",
    "Welcome Talent":"Welcome to talent.gov.hk",
    "Talent information":"talent.gov.hk is an information portal established by the Human Resources Planning Commission of the HKSAR Government, providing consolidated manpower information to facilitate the making of informed choices in respect of career, learning and development pathways.",
    // 'Explorer':'"Explorer" is a monthly online magazine under talent.gov.hk on trending topics in the job market.',
    "Membership and Terms of Reference":"HRPC Membership and Terms of Reference",
    "HRPC Information Centre":"HRPC Information Centre",
    "Press Release":"Press Release",
    "Archive":"Archive",
    "Contact Us":"Contact Us",  
    "Address":"Address",
    "Telephone number":"Telephone number",
    "Please enter your email":"Please enter your email",
    "Please select the type of user":"Please select type of user",
    "Please select the age group":"Please select age group",
    "Please select type of feedback":"Please select type of feedback",
    "Feature stories":"Feature Stories",
    "Human Resources Planning Commission":"Human Resources Planning Commission",
    "Email:":"E-mail: ",
    "Address:":"Address: ",
    "hrpc@cso.gov.hk":"hrpc@cso.gov.hk",
    "2810 2586":"2810 2586",
    "2801 6314":"2801 6314",
    "Human Resources":"Manpower Division, Labour and Welfare Bureau  10/F, West Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong",
    "Telephone:":"Telephone: ",
    "Fax:":"Fax: ",
    "ReratedCourses":"Browse Courses",
    "Slide to view more":"Slide to view more",
    "CEF_text":'The Continuing Education Fund (CEF) subsidises adults with learning aspirations to pursue continuing education and training.  Only continuing education and training courses registered under CEF as "reimbursable courses" are reimbursable under CEF.  The application procedures and a list of the reimbursable courses can be obtained from the [link]',
    "CEF_link_text":"CEF website",
    "CEF_link":"https://www.wfsfaa.gov.hk/cef/en/index.htm",
    "QR_text":'The [link] is a register established by the Secretary for Education under the Accreditation of Academic and Vocational Qualifications Ordinance for entering qualifications recognised under the QF. The Hong Kong Council for Accreditation of Academic and Vocational Qualifications has been specified in the Ordinance as the authority for developing and maintaining the QR. ',
    "QR_link_text":"QR",
    "QR_link":"https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-en/index.html",
    "MOOC_text":'Massive Open Online Course (MOOC) offered by edX.',
    "Copied link to clipboard":"Copied link to clipboard!",
    "Close":"Close",
    "Beta Version":"Beta Version",
    "Powered by":"Powered by",
    "QF level":"QF level ",
    "Discover more career resources":"Discover more career resources",
    "There are no":"There are no relevant results.",
    "description":"Explore over 20000 job vacancies from the government and major job boards, over 300 career profiles and more than 10000 courses to find your ideal career and learning pathways! About us: talent.gov.hk is an information portal established by the Human Resources Planning Commission of the HKSAR Government, providing consolidated manpower information to facilitate the making of informed choices in respect of career, learning and development pathways.",
    'mateMagezine':"Explorer - the magazine of Talent.gov.hk",
    "benefits":"Benefit",
    "location":"Location",
    "There are (number) jobs for you":"There are (number) jobs for you.",
    "Choose a job for more details!":"Click the listed jobs for more details!",
    "Explorer_talent":"Explorer magazine - talent.gov.hk - One-stop Manpower Information Portal",
    "Explorer_desc":'"Explorer" is an online magazine under talent.gov.hk on trending topics on careers, upskilling and the job market',
    "Explorer_title":"Explorer magazine",
    "Featured Jobs":"Hot Vacancies",
    "View all Featured Jobs":"View all",
    "View all Occupation":"View all",
    "Popular Courses":"Popular Courses",
    "View all Popular Courses":"View all",
    "Career Magazine": "Explorer Magazine",
    "Hot Occupations": "Hot Occupations", 
    "Discover": "Discover",
    "browseOccupations": "Career Exploration",
    "findJob": "Vacancies Search",
    "browseCouses": "Browse Courses",
    "careerQuizzes": "Career Quizzes",
    "browseOccupations_text": "Explore our 300+ occupation profiles to discover career possibilities.",
    "findJob_text": "Search for government or private sector jobs that suit you from our vacancies database.",
    "browseCouses_text": "Discover 10000+ courses to build your skills and qualifications.",
    "careerQuizzes_text": "Take our career quizzes to discover jobs matched to your interests, skill and experience.",
    "View all occupations": "View all",
    "View all findJob": "View all",
    "View all browseCouses": "View all",
    "View all careerQuizzes": "Take a quiz",
    "Let get started": "Learn more",
    "Discover Description": "Use our tools to discover your career pathways, learning options and job opportunities.",
    "Default Page Title": "One-stop Manpower Information Portal",
    "Careers_title":"Career Exploration",
    "Careers_desc":"Explore your ideal careers in this database introducing more than 300 occupations, including information on key tasks of the occupations, skill requirements, entry requirements and employment outlook, together with related job vacancies and courses",
    "Courses_desc":"Discover over 10000 learning and upskilling courses in our database on both local courses listed in the Qualifications Register and open online courses listed in an overseas education platform, with information on Continuing Education Fund (CEF) courses",
    "Courses_title": " - Courses - talent.gov.hk",
    "Job_desc": "Daily update over 20000+ job vacancies from the government and major job boards. Search now!",
    "Job_title": " - Vacancies -  talent.gov.hk",
    "Self-Assessment_title":"Career Quizzes",
    "Self-Assessment_desc":"Three career quizzes here can help you explore career pathways and develop insights into career decision-making based on your interests, talents, education and experience!",
    "Default Keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Explorer_Keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Careers_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Courses_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Job_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "Self-Assessment_keywords": "hong kong jobs,jobs hk,career,jobs,salary,搵工,求職,招職,resume,cover letter,CV,find job",
    "View all QR Courses": "View all QR Courses",
    "View all MOOC Courses": "View all MOOC Courses",
    "Entry level": "Entry level",
    "Part time": "Part time",
    "Government vacancies": "Government vacancies",
    "Job Creation Scheme": "Job Creation Scheme",
    "Instant-filter": "Quick filter",
    "min":"min",
    "hour":"hour",
    "s":"s",
    "Programme Requirement":"Programme Requirement",

    "RelatedOccupation": "Relevant Occupations",

    "popUp Submit": "Confirm",
    "Cancel": "Cancel",
    "personal information": "Send Quiz Result by Email",
    "quiz content": "You may leave your email for receiving the quiz result and subscribing our “Explorer” online magazine",
    "emailInputTip": "Enter your email address",
    "tips": "The personal data provided by you will only be used for sending you the quiz results and subscribing the 'Explorer' online magazine.  Your personal data will be kept by talent.gov.hk for a reasonable period of time as may be required for the above specific purposes for which they were collected and be erased afterwards.  Should you have any questions regarding the collection of personal data on this form (including requests for access to/ correction of personal data), please contact us at <span style='text-decoration: underline;'>hrpc@cso.gov.hk.</span>",
    "thanksTitle": "THANK YOU FOR YOUR PARTICIPATION!",
    "thanksContent": "Thank you for your support towards talent.gov.hk and the \"Explorer\" online magazine. You will receive an email containing the quiz results and confirmation of your subscription later on.",
    "thanksTips": "If you are using Gmail and still have not received the email after 7 days, it is possible that the email  has been misclassified as junk mail and placed in the junk mail box.",
    "errorTips": "Please enter a valid email address.",
    "course requirements": "Requirements",
    "QR Course": "QR Course",
    "Course View all": "View all",
    "cef course_link": "https://www.wfsfaa.gov.hk/cef/en/preparation/courses.htm",
    "cef course providers_link": "https://www.wfsfaa.gov.hk/cef/en/preparation/providers.htm",
    "CEF course providers": "CEF course providers",
    "Exam Remarks": "Exam Remarks",
    "Fee": "Fee",
    "Instructors Qualifications": "Instructors's Qualifications",
    "Benchmark Exam": "Benchmark Exam",
    "Assessment Methods": "Assessment Methods",
    "Course Outline": "Course Outline",
    "CEF course": "Related CEF Course Information",
    "Course Code": "CEF course number: ",
    "Effective Date": "CEF Effective Date: ",
    "CEF Registration Invalid From": "CEF Registration Invalid From: ",
    "Duration": "Duration",
    "Entry Requirement": "Entry Requirement",
    "Refund Arrangement Of Course Providers": "Refund Arrangement Of Course Providers",
    "Related QR Course": "Related QR Course",
    "learnMore": "Learn More",
    "Eight Centres" : "Eight Centres",
    "hongKongEightCentres": "Eight Centres",
    "descriptHongKongEightCentres": "Discover the career opportunities offered by the eight key areas for the development of Hong Kong as outlined in the National 14th Five-Year Plan ",
    "internationalInnovationAndTechnologyCentre": "International Innovation and Technology Centre",
    "descriptInternationalInnovationAndTechnologyCentre": "Poneering advancements in AI, biotech, and smart city solutions.",
    "internationalTransportationCentre": "International Transportation Centre",
    "descriptInternationalTransportationCentre": "A global hub for logistic and supply chain management.",
    "internationalAviationHub": "International Aviation Hub",
    "descriptInternationalAviationHub": "Connecting the world with world-class aviation services.",
    "eastMeetsWestCentre": "East-meets-West Centre for International Cultural Exchange",
    "descriptEastMeetsWestCentre": "Focusing global cultural dialogue and createive collaborarion.",
    "internationalFinacialCentre": "International Finacial Centre",
    "descriptInternationalFinacialCentre": "A global leader in bankin, fintech, and capital markets.",
    "regionalIntellectualPropertyTradingCentre": "Regional Intellectual Property Trading Centre",
    "descriptRegionalIntellectualPropertyTradingCentre": "Driving innocation through IP protection and trading.",
    "internationalLegalService": "Reginal Centre for International Legal and Dispute Resolution Service",
    "descriptinternationalLegalService": "Porviding trusted legal and arbitration servies globally",
    "internationalTradeCentre": "International Trade Centre",
    "descriptInternationalTradeCentre": "Faciliating global trade with robust commercial networks.",
  },
    centresLabel:{
    "manPowerProject": "Manpower Projection for " ,
    "balanceGroup": "Manpower Balance by Occupation Group for " ,
    "factor" : " Key Factors Impacting Outlook "
    },
    eightCentres:{
    "projection2028":"Manpower Projection for ",
    "manpowerRequirments":"Manpower Requirements for 2028",
    "from2023to2028":"From 2023 to 2028",
    "projectedChange": "Projected change",
    "annualChange": "Annual change",
    "sectoralManpowerBalance": "Sectoral Manpower Balance",
    "manpowerBalanceByOccupationGroup":"Manpower Balance by Occupation Group for 2028",
    "managersSupervidorsAndProfessionals":"Managers, supervisors and professionals",
    "serviceIndustryWorkers":"Service industry workers",
    "skilledTechnicalWorkers":"Skilled technical workers",
    "manualLabourers":"Manual labourers",
    "keyFactorsImpactingOutlook":"Key Factors Impacting Outlook",
    "occupationsInDemand":"Occupations in Demand",
    "essentialSkillsKnowledge" : "Essential Skills / Knowledge",
    "skills" : "Skills",
    "knowledge" : "Knowledge",
    "adaptabilityAndLearningAgility" : "Adaptability and learning agility",
    "businessAcumenAndEntrepreneurship" : "Business acumen and entrepreneurship",
    "collaborationAndTeamwork" : "Collaboration and teamwork",
    "communicationSkills" : "Communication skills",
    "criticalThinkingAndProblemSolving" : "Critical thinking and problem solving",
    "dataAnalyticalSkills" : "Data analytical skills",
    "digitalProficiency" : "Digital proficiency",
    "financialManagementAndFundraisingAcumen" : "Financial management and fundraising acumen",
    "innovationAndCreativity" : "Innovation and creativity",
    "multilingualCompetence" : "Multilingual competence",
    "rdProjectManagement" : "R&D project management",
    "globalTechnologyDevelopmentTrends" : "Global technology development trends",
    "esgPrinciples" : "ESG principles",
    "itRelatedRegulatoryKnowledge" : "I&T related regulatory knowledge",
    "intellectualPropertyLiteracy" : "Intellectual property (IP) literacy (e.g. IP management and commercialisation)",
    "nationalAndGbaDevelopmentStrategiesAndMarketTrends" : "National and GBA development strategies and market trends",
    "userExperienceUserInterfaceDesign" : "User experience (UX) / user interface (UI) design",
    "digitalMarketing" : "Digital marketing",
    "eCommerce" : "E-commerce",
    "digitalLiteracy" : "Digital literacy",
    "transportationRelatedRegulatoryKnowledge" : "Transportation related regulatory knowledge",
    "customerServiceAndComplaintHandling" : "Customer service and complaint handling",
    "flightSafetyAndRiskManagement" : "Flight safety and risk management",
    "resilienceAndStressManagement" : "Resilience and stress management",
    "routeDevelopment" : "Route development",
    "aviationRegulatoryKnowledge" : "Aviation regulatory knowledge",
    "storytellingAndContentCreation" : "Storytelling and content creation",
    "artTechnology" : "Art technology",
    "culturalAwarenessAndSensitivity" : "Cultural awareness and sensitivity",
    "globalAndMainlandCulturalAndCreativeMarketDevelopmentTrends" : "Global and Mainland cultural and creative market development trends",
    "ipLiteracy" : "IP literacy",
    "antiMoneyLaundering" : "Anti money laundering",
    "blockchainAndCryptocurrency" : "Blockchain and cryptocurrency",
    "financialAndBankingRelatedRegulatoryKnowledge" : "Financial and banking related regulatory knowledge",
    "greenFinance" : "Green finance",
    "patentDraftingProsecutionAndAnalytics" : "Patent drafting, prosecution and analytics",
    "knowledgeOfNationalAndInternationalPatentSystems" : "Knowledge of national and international patent systems",
    "alternativeDisputeResolutionTechniques" : "Alternative dispute resolution techniques",
    "blockchainAndVirtualAssetsAndTheirRegulatoryFramework" : "Blockchain and virtual assets, and their regulatory framework",
    "contractLawInEvents" : "Contract law in events",
    "intellectualPropertyLawPatentProtection" : "Intellectual property law / Patent protection",
    "lawForArtAndCulture" : "Law for art and culture",
    "mainlandLaw" : "Mainland law",
    "maritimeLaw" : "Maritime law",
    "lawForItAndCyberSecurity" : "Law for I&T and cyber security",
    "globalSupplyChainManagement" : "Global supply chain management",
    "insightsIntoEmergingMarkets" : "Insights into emerging markets (South East Asia, Middle East, etc.)",
    "tradeRelatedRegulatoryKnowledge" : "Trade related regulatory knowledge",
    "trendsInInternationalTradeAndGeopoliticalTensions" : "Trends in international trade and geopolitical tensions",
  },
  technology:{
    "sectionOneContent1":"Life & health technology",
    "sectionOneContent2":"AI & data science",
    "sectionOneContent3":"Advanced manufacturing and new energy",
    "sectoralManpowerBalance_number": "-18 000 to -23 000",
    "managersSupervidorsAndProfessionals_number": "-17 000 to -21 000",
    "serviceIndustryWorkers_number": "-500 to -1 500",
    "skilledTechnicalWorkers_number": "Within ±500",
    "manualLabourers_number": "Not applicable",
    "itEcosystemDevelopment": "I&T ecosystem development",
    "developmentOfNewIndustrialisation": "Development of new industrialisation",
    "digitalisationAndAiAdoption": "Digitalisation and AI adoption",
    "integrationWithGBA": "Integration with GBA",
    "strongPolicySupport": "Strong policy support",
    "overall": "Overall",
    "aiAndDataScience": "AI and data science",
    "lifeAndHealthTechnology": "Life and health technology",
    "advancedManufacturingAndNewEnergy": "Advanced manufacturing and new energy",
    "dataAnalysts": "Data analysts",
    "entrepreneursStartupAdvisors": "Entrepreneurs / startup advisors",
    "ipExperts": "IP experts",
    "projectManagers": "Project managers",
    "regulatoryAffairSpecialists": "Regulatory affair specialists",
    "emMechanicsTechnicians": "E&M mechanics / technicians (systems/ data centre and network installation)",
    "aiProgrammersSpecialists": "AI programmers / specialists",
    "businessAnalystsAndDataScientists": "Business analysts and data scientists",
    "cloudInfrastructureSpecialists": "Cloud infrastructure specialists",
    "cyberSecuritySpecialists": "Cyber security specialists",
    "digitalTransformationExperts": "Digital transformation experts",
    "roboticsExperts": "Robotics experts",
    "systemArchitects": "System architects",
    "medicalLaboratoryTechnologists": "Medical laboratory technologists",
    "pharmaceuticalProcessDevelopingEngineers": "Pharmaceutical process developing engineers",
    "electronicEngineers": "Electronic engineers",
    "microelectronicsExperts": "Microelectronics experts",
    "newEnergyExperts": "New energy experts",
  },
    transportation:{
      "landPassengerTransport": "Land passenger transport",
      "waterPassengerTransport": "Water passenger transport",
      "landAndWaterLogisticsServices": "Land and water logistics services",
      "sectoralManpowerBalance_number": "-10 000 to -15000",
      "managersSupervidorsAndProfessionals_number": "-500 to -1 000",
      "serviceIndustryWorkers_number": "-2 000 to -3 500",
      "skilledTechnicalWorkers_number": "-4 500 to -6 500",
      "manualLabourers_number": "-3 000 to -4 000",
      "captainsChiefOfficers": "Captains/ Chief officers",
      "charteredShipSurveyors": "Chartered ship surveyors",
      "dataAnalysts": "Data analysts",
      "itAndDigitalisationStaff": "IT and digitalisation staff",
      "signalEngineers": "Signal engineers",
      "cargoControllers": "Cargo controllers",
      "customerServiceOfficersAndServiceAssistants": "Customer service officers and service assistants",
      "drivers": "Drivers",
      "emMechanicsTechnicians": "E&M mechanics / technicians (including maritime services and vehicle maintenance)",
      "seafarers": "Seafarers",
      "smartLogisticsFacilityAndMachineryOperators": "Smart logistics facility and machinery operators / technicians",
      "warehouseOperativeStaffAndPorters": "Warehouse operative staff and porters",
      "greenTransportation": "Green transportation",
      "integrationWithGBA": "Integration with GBA",
      "riseOfeCcommerce": "Rise of e-commerce",
      "technologicalAdvancements": "Technological advancements",
      "transportNetworkDevelopment": "Transport network development",
      "digitalLiteracy": "Digital literacy (e.g. autonomous vehicles and traffic management and smart logistics systems)",
    },
    aviationHub:{
      "airTransportServices" : "Air transport services (including air passenger transport, air freight transport and aircraft maintenance)",
      "sectoralManpowerBalance_number" : "-18 000 to -23 000",
      "managersSupervidorsAndProfessionals_number" : "-5 500 to -7 000",
      "serviceIndustryWorkers_number" : "-8 500 to -10 000",
      "skilledTechnicalWorkers_number" : "-3 200 to -4 200",
      "manualLabourers_number" : "-800 to -1 800",
      "commissioningOfTheThree-RunwaySystem" : "Commissioning of the Three-Runway System",
      "expansionOfAviationNetwork" : "Expansion of aviation network",
      "expansionOfAirportCity" : "Expansion of Airport City",
      "enhancementInIntermodalConnectivity" : "Enhancement in intermodal connectivity for passenger and cargo in GBA",
      "increaseInTourismAppealOfHongKong" : "Increase in tourism appeal of Hong Kong",
      "increaseInTravelDemandWithinGBA" : "Increase in travel demand within GBA",
      "aircraftEngineers" : "Aircraft engineers",
      "aircraftPilots" : "Aircraft pilots",
      "aircraftSafetyOfficers" : "Aircraft safety officers",
      "dataAnalysts" : "Data analysts",
      "itAndDigitalisationStaff" : "IT and digitalisation staff",
      "routeDevelopmentOfficers" : "Route development officers",
      "customerServiceOfficers" : "Customer service officers",
      "travelAttendant" : "Travel attendants (cabin crew)",
      "aircraftMaintenanceMechanic" : "Aircraft maintenance mechanics/ technicians",
      "airportOperationalSupportingStaff" : "Airport operational supporting staff (e.g. passenger service officers, ramp service agents, airport tug drivers, tractor drivers, equipment / loader operators as well as E&M mechanics / technicians)",
      "cleanersCabinWorkers" : "Cleaners / cabin workers",
      "warehouseOperativeStaff" : "Warehouse operative staff and porters / cargo handlers",
      "digitalLiteracy" : "Digital literacy (e.g. customer service bots and flight scheduling apps)",
    },
    eastMeetsWest:{
      "artAntiquesAndCrafts" : "Art, antiques and crafts",
      "culturalEducationLibraryArchiveandMuseumServices" : "Cultural education, library, archive and museum services",
      "performingArts" : "Performing arts",
      "filmVideoAndMusic" : "Film, video and music",
      "televisionAndRadio" : "Television and radio",
      "publishing" : "Publishing",
      "softwareInteractiveMedia" : "Software, computer games and interactive media",
      "design" : "Design",
      "architecture" : "Architecture",
      "advertising" : "Advertising",
      "amusementServices" : "Amusement services",
      "sectoralManpowerBalance_number" : "-5 000 to -8 000",
      "managersSupervidorsAndProfessionals_number" : "-5 500 to -7 500",
      "serviceIndustryWorkers_number" : "within ±500",
      "skilledTechnicalWorkers_number" : "within ±500",
      "manualLabourers_number" : "within ±500",
      "integrationWithGBA" : "Integration with GBA",
      "developmentOperationOfNewAndMajorCulturalFacilities" : "Development/ operation of new and major cultural facilities",
      "policiesToPromoteDevelopmentOfArtsAndCulture" : "Policies to promote development of arts and culture",
      "technologyAndAI" : "Technology and AI",
      "artsAdministrationAndManagementSpecialists" : "Arts administration and management specialists",
      "artsEducators" : "Arts educators",
      "artsProjectFinancingExperts" : "Arts project financing experts",
      "artsTechSpecialists" : "Arts tech specialists",
      "artsTradingSpecialists" : "Arts trading specialists",
      "artworkAppraisers" : "Artwork appraisers",
      "conservationSpecialists" : "Conservation specialists",
      "creativeDirectors" : "Creative directors",
      "culturalIntellectualPropertyExperts" : "Cultural intellectual property (IP) experts",
      "curators" : "Curators",
      "itandDigitalisationStaff" : "IT and digitalisation staff",
      "emMechanicsTechnicians" : "E&M mechanics /technicians (including stage lighting and sound specialists)",
      "ipLiteracy" : "IP literacy (e.g. IP management and commercialisation)",
    },
    financial:{
      "banking" : "Banking",
      "stockBrokerageAndAssetManagement" : "Stock brokerage and asset management",
      "insurance" : "Insurance",
      "sectoralManpowerBalance_number" : "-1 500 to -4 500",
      "managersSupervidorsAndProfessionals_number" : "-2 000 to -3 000",
      "serviceIndustryWorkers_number" : "within ±500",
      "skilledTechnicalWorkers_number" : "within ±500",
      "manualLabourers_number" : "within ±500",
      "esgAwareness" : "ESG awareness",
      "fintechDevelopment" : "Fintech development",
      "mutualMarketAccess" : "Mutual market access",
      "newListingRulesInHongKong" : "New listing rules in Hong Kong",
      "offshoreRenminbiHub" : "Offshore Renminbi hub",
      "virtualAssetsEcosystem" : "Virtual assets ecosystem",
      "accountants" : "Accountants",
      "assetAndWealthManagementProfessionals" : "Asset and wealth management professionals",
      "complianceAndRiskManagementProfessionals" : "Compliance and risk management professionals",
      "data analysts" : "Data analysts",
      "esgAnalystsSustainabilityOfficers" : "ESG analysts / sustainability officers",
      "fintechAndBlockchainSpecialists" : "Fintech and blockchain specialists",
      "itAndDigitalisationStaff" : "IT and digitalisation staff",
      "relationshipManagers" : "Relationship managers",
      "specialistInsuranceProfessionals" : "Specialist insurance professionals",
      "technicalSales" : "Technical sales",
      "emMechanics" : "E&M mechanics",
      "digitalLiteracy" : "Digital literacy (e.g. AI application – customer service bots and online banking)",
    },
    propertyTrading:{
      "intellectualPropertyIntermediaries" : "Intellectual property (IP) intermediaries",
      "ipIntensiveIndustries" : "IP intensive industries",
      "sectoralManpowerBalance_number" : "-1 000 to -4 000",
      "managersSupervidorsAndProfessionals_number" : "-500 to -2 500",
      "serviceIndustryWorkers_number" : "-500 to -1 500",
      "skilledTechnicalWorkers_number" : "not applicable",
      "manualLabourers_number" : "not applicable",
      "itEcosystemDevelopment" : "I&T ecosystem development",
      "ipDevelopmentInTheMainland" : "IP development in the Mainland",
      "originalGrantPatentsystemDevelopmentInHK" : "Original grant patent system development in HK",
      "policiesToPromoteThedevelopmentOfCulturalAndCreativeIndustries" : "Policies to promote the development of cultural and creative industries",
      "ipManagers" : "IP managers",
      "ipServiceProfessionals" : "IP service professionals",
    },
    legalService:{
      "legalAndDisputeResolutionServices" : "Legal and dispute resolution services",
      "arbitrationAndMediationPlatformsAndSupportingServices" : "Arbitration and mediation platforms and supporting services",
      "sectoralManpowerBalance_number" : "within ±500",
      "financialMarketRebound" : "Financial market rebound",
      "itAndIpRelatedLegalRegime" : "I&T and IP related legal regime",
      "integrationWithGba" : "Integration with GBA",
      "demandForLegalServicesInArtCultureAndEventSectors" : "Demand for legal services in art, culture and event sectors",
      "nationalPoliciesSupportingAlternativeDisputeResolution" : "National policies supporting alternative dispute resolution",
      "alternativeDisputeResolutionProfessionals" : "Alternative dispute resolution professionals (arbitrators and mediators)",
      "ItAndDigitalisationStaff" : "IT and digitalisation staff",
      "legalKnowledgeEngineers" : "Legal knowledge engineers",
      "legalTechnologistsAndAutomationSpecialists" : "Legal technologists and automation specialists",
    },
    trade:{
      "trading" : "Trading (import, export and wholesale trades)",
      "logistics" : "Logistics",
      "sectoralManpowerBalance_number" : "-11 000 to -16 000",
      "managersSupervidorsAndProfessionals_number" : "-2 000 to -3 000",
      "serviceIndustryWorkers_number" : "-600 to -1 600",
      "skilledTechnicalWorkers_number" : "-4 400 to -5 400",
      "manualLabourers_number" : "-4 000 to -6 000",
      "OffshoreTradePlatforms" : "Offshore trade platforms",
      "regionalCooperationAndBeltAndRoadInitiative" : "Regional cooperation and Belt and Road Initiative",
      "riseOfeCommerce" : "Rise of e-commerce",
      "transformationToHighValueAddedServices" : "Transformation to high value-added services",
      "dataAnalysts" : "Data analysts",
      "digitalMarketingProfessionals" : "Digital marketing professionals",
      "eCommerceProfessionals" : "E-commerce professionals",
      "esgAnalystsSustainabilityOfficers" : "ESG analysts / sustainability officers",
      "globalSupplyChainManagementSystemSpecialists" : "Global supply chain management system specialists",
      "itAndDigitalisationStaff" : "IT and digitalisation staff",
      "emMechanicsTechnicians" : "E&M mechanics /technicians",
      "warehouseOperativeStaffAndPorter" : "Warehouse operative staff and porter",
      "digitalLiteracy" : "Digital literacy (e.g. digitalisation of customer and shipping documents)",
      "" : "",
      "" : "",
      "" : "",
    },
}